import {Component, Input} from "@angular/core";
import {UnauthorizedError} from "./unauthorized-error";
import {MultiError} from "./multi-error";

@Component({
  selector: "error",
  templateUrl: "./error-component.template.pug",
})
export class ErrorComponent {
  private _error: Error;
  showError: boolean;
  errorData: any[] = [];
  IspartiallySuccess: boolean = false;
  
  @Input()
  set error(error: Error) {
    this._error = error;
    this.calculateShowError();
  }

  get error(): Error {
    return this._error;
  }

  @Input() showPossibleResolution: any;
  @Input() guideLink: string = "";
  

  constructor() {}

  calculateShowError() {
    if(this.error){
    if(this.error.message.includes('partially success')){
      this.IspartiallySuccess = true;
      this.showError = false;
      return;
    }}
    if (!this.error) {
      this.showError = false;
      this.IspartiallySuccess = false;
      return;
    }

    if (this.error instanceof UnauthorizedError) {
      this.showError = false;
      this.IspartiallySuccess = false;
      return;
    }

    if (this.error instanceof MultiError) {
      for (const e of this.error["errors"]) {
        if (e instanceof UnauthorizedError) {
          this.showError = false;
          this.IspartiallySuccess = false;
          return;
        }
      }
    }

    this.showError = true;
  }
}
